var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pb-12" }, [
    _c(
      "div",
      { staticClass: "mx-4 lg:mx-auto pb-16 pt-20 lg:pt-32 max-w-4xl" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex flex-col justify-center px-4 lg:px-12 py-6 border border-[#3e90ff] rounded-[12px] lg:rounded-[30px]",
          },
          [
            _vm._m(0),
            _vm.status === "default"
              ? _c(
                  "a-form",
                  {
                    attrs: {
                      form: _vm.form,
                      "label-col": { span: 5 },
                      "wrapper-col": { span: 12 },
                    },
                    on: { submit: _vm.handleSubmit },
                  },
                  [
                    _c(
                      "a-form-item",
                      { staticClass: "mb-8", attrs: { label: "公司名称" } },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "businessName",
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: "请输入公司名称",
                                    },
                                  ],
                                },
                              ],
                              expression:
                                "['businessName', { rules: [{ required: true, message: '请输入公司名称' }] }]",
                            },
                          ],
                          attrs: {
                            placeholder: "请输入公司名称",
                            maxLength: 50,
                            allowClear: "",
                            size: "large",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      { staticClass: "mb-8", attrs: { label: "用户名称" } },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "userName",
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: "请输入您的姓名",
                                    },
                                  ],
                                },
                              ],
                              expression:
                                "['userName', { rules: [{ required: true, message: '请输入您的姓名' }] }]",
                            },
                          ],
                          attrs: {
                            placeholder: "请输入您的姓名",
                            maxLength: 50,
                            allowClear: "",
                            size: "large",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      { staticClass: "mb-8", attrs: { label: "联系电话" } },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: [
                                "phone",
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: "请输入你的联系电话",
                                    },
                                    {
                                      pattern: /^1[3456789]\d{9}$/,
                                      message: "请输入有效的中国大陆手机号码!",
                                    },
                                  ],
                                },
                              ],
                              expression:
                                "['phone', {\n                        rules: [\n                            { required: true, message: '请输入你的联系电话' },\n                            { pattern: /^1[3456789]\\d{9}$/, message: '请输入有效的中国大陆手机号码!' }\n                        ]\n                    }]",
                            },
                          ],
                          attrs: {
                            placeholder: "请输入你的联系电话",
                            maxLength: 50,
                            allowClear: "",
                            size: "large",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        staticClass: "hidden lg:block mb-8",
                        attrs: { "wrapper-col": { span: 12, offset: 5 } },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              "html-type": "submit",
                              block: "",
                              size: "large",
                              loading: _vm.loading,
                            },
                          },
                          [_vm._v(" 点击提交 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      { staticClass: "block lg:hidden mb-8" },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              "html-type": "submit",
                              block: "",
                              loading: _vm.loading,
                            },
                          },
                          [_vm._v(" 点击提交 ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.status === "success"
              ? _c("a-result", {
                  attrs: { status: "success", title: "提交成功！" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "extra",
                        fn: function () {
                          return [
                            _c(
                              "a-button",
                              {
                                key: "console",
                                attrs: { type: "primary" },
                                on: { click: _vm.goHome },
                              },
                              [_vm._v(" 回到首页 ")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4258185867
                  ),
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mb-12" }, [
      _c(
        "p",
        { staticClass: "mt-4 lg:mt-8 text-lg lg:text-2xl font-semibold" },
        [_vm._v("申请演示")]
      ),
      _c("p", { staticClass: "mt-2 text-sm lg:text-lg" }, [
        _vm._v("留下您的联系方式，我们尽快与您联系"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }